<div class="menu">
  <ul class="sider-menu w-100"
      [style]="setMenuPlacement()"
      nz-menu
      [nzMode]="config?.mode"
      [nzInlineCollapsed]="isCollapsed"
      [style.backgroundColor]="config?.backgroundColor">
    <ng-container *ngTemplateOutlet="recursiveMenuList; context:{ $implicit: config?.items }"></ng-container>

    <ng-template class="menu-liste"
                 #recursiveMenuList
                 let-menus>
      <ng-container *ngFor="let menu of menus">
        <li *ngIf="menu?.children?.length; else menuItem"
            nz-submenu
            [nzMenuClassName]="config?.mode === MenuMode.Horizontal ? 'menu-submenu-horizontal' : null"
            [(nzOpen)]="menu.isExpanded"
            [nzTitle]="submenuTitle"
            [nzDisabled]="menu?.disabled || isDisabled"
            [style]="menu?.style"
            (nzOpenChange)="openHandler($event, menu)">
          <ng-template #submenuTitle>
            <div class="menu-item-icon-container">
              <rappider-icon *ngIf="menu?.icon?.name"
                             class="menu-item-icon"
                             [name]="menu?.icon?.name"
                             [theme]="menu?.icon?.theme"
                             [type]="menu?.icon?.type"
                             [color]="menu?.icon?.color"
                             [size]="menu?.icon.size"></rappider-icon>
              <div *ngIf="showLabels || menu.showLabel"
                   class="menu-item-label-container">
                <span class="menu-item-label"
                      [style]="menu?.style">{{ menu?.label | translate }}</span>
                <p *ngIf="menu?.description"
                   class="menu-item-description">{{ menu?.description | translate }}</p>
              </div>
              <nz-tag *ngIf="menu?.tag"
                      class="menu-tag"
                      [nzColor]="menu?.tagColor">{{menu?.tag}}</nz-tag>
            </div>
          </ng-template>
          <ul>
            <ng-container *ngTemplateOutlet="recursiveMenuList; context:{ $implicit: menu?.children }"></ng-container>
          </ul>
        </li>

        <ng-template #menuItem>

          <li *ngIf="menu?.joyride?.joyrideStep"
              [joyrideStep]="menu?.joyride?.joyrideStep"
              [title]="menu?.joyride?.title"
              [text]="menu?.joyride?.text"
              (next)='onNext(menu?.joyride?.joyrideStep)'
              nz-menu-item
              nz-tooltip
              [nzDisabled]="menu?.disabled"
              [nzSelected]="menu?.selected"
              [nzPaddingLeft]="getPaddingLeftValue(menu?.level)"
              [nzTooltipTitle]="menu?.tooltip"
              [nzTooltipPlacement]="menu?.tooltipPlacement ?? 'right'"
              [nzTooltipVisible]="menu?.tooltipVisible"
              [nzTooltipTrigger]="menu?.tooltipTrigger ?? 'hover'"
              nzTooltipOverlayClassName="menu-tooltip"
              (click)="menuClick($event, menu)">
            <ng-container *ngIf="menu?.icon && menu.icon?.name">
              <div class="menu-item-icon-container">
                <rappider-icon class="menu-item-icon"
                               [name]="menu?.icon.name"
                               [theme]="menu?.icon.theme"
                               [type]="menu?.icon.type"
                               [color]="menu?.icon.color"
                               [size]="menu?.icon.size"></rappider-icon>
                <div *ngIf="showLabels || menu.showLabel"
                     class="menu-item-label-container">
                  <span class="menu-item-label"
                        [style]="menu?.style">{{ menu?.label | translate }}</span>
                  <p *ngIf="menu?.description"
                     class="menu-item-description">{{ menu?.description | translate }}</p>
                </div>
                <nz-tag *ngIf="menu?.tag"
                        class="menu-tag"
                        [nzColor]="menu?.tagColor">{{menu?.tag}}</nz-tag>
              </div>
            </ng-container>
            <ng-container *ngIf="!menu?.icon">
              <div *ngIf="showLabels || menu.showLabel"
                   class="menu-item-label-container">
                <span class="menu-item-label"
                      [style]="menu?.style">{{ menu?.label | translate }}</span>
                <p *ngIf="menu?.description"
                   class="menu-item-description">{{ menu?.description | translate }}</p>
              </div>
              <nz-tag *ngIf="menu?.tag"
                      class="menu-tag"
                      [nzColor]="menu?.tagColor">{{menu?.tag}}</nz-tag>
            </ng-container>
          </li>

          <li *ngIf="!menu?.joyride?.joyrideStep"
              nz-menu-item
              nz-tooltip
              [nzDisabled]="menu?.disabled"
              [nzSelected]="menu?.selected"
              [nzPaddingLeft]="getPaddingLeftValue(menu?.level)"
              [nzTooltipTitle]="menu?.tooltip"
              [nzTooltipPlacement]="menu?.tooltipPlacement ?? 'right'"
              [nzTooltipVisible]="menu?.tooltipVisible"
              [nzTooltipTrigger]="menu?.tooltipTrigger ?? 'hover'"
              nzTooltipOverlayClassName="menu-tooltip"
              (click)="menuClick($event, menu)">
            <ng-container *ngIf="menu?.icon && menu.icon?.name">
              <div class="menu-item-icon-container">
                <rappider-icon class="menu-item-icon"
                               [name]="menu?.icon.name"
                               [theme]="menu?.icon.theme"
                               [type]="menu?.icon.type"
                               [color]="menu?.icon.color"
                               [size]="menu?.icon.size"></rappider-icon>
                <div *ngIf="showLabels || menu.showLabel"
                     class="menu-item-label-container">
                  <span class="menu-item-label"
                        [style]="menu?.style">{{ menu?.label | translate }}</span>
                  <p *ngIf="menu?.description"
                     class="menu-item-description">{{ menu?.description | translate }}</p>
                </div>
                <nz-tag *ngIf="menu?.tag"
                        class="menu-tag"
                        [nzColor]="menu?.tagColor">{{menu?.tag}}</nz-tag>
              </div>
            </ng-container>
            <ng-container *ngIf="!menu?.icon">
              <div *ngIf="showLabels || menu.showLabel"
                   class="menu-item-label-container">
                <span class="menu-item-label"
                      [style]="menu?.style"
                      nz-tooltip
                      nzTooltipPlacement="right"
                      nzTooltipTitle="{{ menu?.label | translate }}">{{ menu?.label | translate }}</span>
                <p *ngIf="menu?.description"
                   class="menu-item-description">{{ menu?.description | translate }}</p>
              </div>
              <nz-tag *ngIf="menu?.tag"
                      class="menu-tag"
                      [nzColor]="menu?.tagColor">{{menu?.tag}}</nz-tag>
            </ng-container>
          </li>
        </ng-template>
      </ng-container>
    </ng-template>
  </ul>
</div>
